<template>
  <!-- 视频点播 -->
  <div class="video_warp">
    <BasePage ref="basePage">
      <template scope="{item}">
        <div class="list_item" @click="toDetail(item)">
          <div class="item_img_box">
            <el-image class="item_img" :src="item.image">
              <div slot="placeholder" class="image_slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div class="img_time_box">
              <i class="el-icon-video-play" style="font-size:60px"></i>
            </div>
          </div>
          <div class="item_info">
            <div class="item_info_title ellipsis">{{ item.title }}</div>
            <div class="bot">
              <span style="margin-right:auto;color: #2f7ef7;">播放 0</span>
              <!-- <svg-icon icon-class="comment" class-name="card-panel-icon" /> -->
              <i class="el-icon-star-off card-panel-icon" />
              <span style="margin-right:16px">{{ item.scs }}</span>
              <svg-icon icon-class="thumb" class-name="card-panel-icon" />
              <span>{{ item.dzs }}</span>
            </div>
            <div class="item_footer">
              <img class="item_footer_icon" :src="item.venueLogo" />
              <span>{{ item.venueName }}</span>
            </div>
          </div>
        </div>
      </template>
    </BasePage>
  </div>
</template>

<script>
import BasePage from "@c/BasePage";

export default {
  name: "videos",
  components: {
    BasePage,
  },
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    this.$refs.basePage.loadImage(to.query.id);
    next();
  },
  methods: {
    toDetail(item) {
      this.$router.push(`/video/detail/${item.id}`);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import "@/styles/com_item.scss";

.video_warp {
  background: #f8f8f8;

  .item_img_box {
    .item_img {
      width: 100%;
      height: 100%;
      ::v-deep {
        img {
          object-fit: cover;
        }
      }
    }
  }
}
</style>
